//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	name: 'leftcolumn',
	data() {
		return {
			flag:true
		}
	},
	methods: {
		to_box() {
			if (this.$route.name == 'officialHome') {
				this.set_se_scroll(true)
				setTimeout(() => {
					this.set_se_scroll(false)
				}, 300)
			} else {
				this.$router.push({
					path: '/official/home',
					query: {
						scroll: 'scroll'
					}
				})
			}
		},
		Jump(path) {
				this.$router.push({path})

		},

		//跳转egg样式
		toEgg() {
			if(this.flag == true) {
				this.flag = false
				setTimeout(()=>{
					this.flag = true
				},1000)
			}
			
			this.$router.push('/');
			// // 
			// return
			// if (this.$route.name == 'officialHome') {
			// 	this.station('')
			// } else {
			// 	this.station('knapsack')
			// }
			
		},

		//跨站跳转
		station(path) {
			if (sessionStorage.getItem('renew')) {
				let list = JSON.parse(sessionStorage.getItem('renew'))
				if (list.length > 0) {
					this.set_messageData({
						show: true,
						text: '库存中还有新饰品刮刮乐<br/>确定切换风格吗？',
						path: path
					})
				} else {
					this.set_messageData({
						show: true,
						text: '<br/>进入页面将切换至原始风格',
						path: path
					})
				}
			} else {
				this.set_messageData({
					show: true,
					text: '<br/>进入页面将切换至原始风格',
					path: path
				})
			}
		}
	},
	computed: {
		...mapState(['box_active'])
	}
}
